import React, { Component } from 'react';
import {
  Redirect
} from "react-router-dom";
import { Dimmer, Loader, Container, Tab, Image, Icon } from "semantic-ui-react";
import { translate } from 'react-i18next';
import {notify} from 'react-notify-toast';
import Header from '../components/Header'
import ProfilePane from '../components/ProfilePane'
import PremiumPane from '../components/PremiumPane'
import API from '../utils/API'
import PersonalDataPane from '../components/PersonalDataPane';
import GiftCardsPane from '../components/GiftCardsPane';
import {
  BrowserView,
  MobileView
} from "react-device-detect";
import ProfileCard from '../components/ProfileCard';
import GiftCardsCard from '../components/GiftCardsCard';
import PersonalDataCard from '../components/PersonalDataCard';
import PremiumCard from '../components/PremiumCard';

class HomePage extends Component {
  state = {
    fetching: false,
    user: null,
    blocked: false,
    userLogged: true
  }


  componentDidMount () {
    try {
      const token = window.localStorage.gwps
      this.localStorageAvailable = true
    } catch(e) {
      this.localStorageAvailable = false
    }
    if (!this.localStorageAvailable || (!window.localStorage.gwps && !(this.props.location.state && this.props.location.state.user))) {
      this.setState({userLogged: false})
    } else {
      this.getUser()
    }
    // else if (!(this.props.location.state && this.props.location.state.user)) {
    //   this.getUser()
    // }
    // else {
    //   this.setState({user: this.props.location.state.user})
    // }
  }

  logout () {
    delete window.localStorage.gwps
    window.location.reload()
  }

  async getUser () {
    if (window.localStorage.gwps) {
      this.setState({fetching: true})
      const response = await API.getUser()
      console.log(response)
      if (response.ok) {
        notify.show(this.props.t('messages:welcome', {firstname: response.data.firstname}), 'success')
        this.setState({fetching: false, user: response.data})
      } else {
        notify.show(this.props.t('messages:error'), 'error')
        this.setState({fetching: false})
        this.logout()
      }
    }
  }

  toggleTabs() {
    this.setState({blocked: !this.state.blocked})
  }

  updateUser (newUser) {
    this.setState({user: {...this.state.user, ...newUser}})
  }

  onTabChange (e) {
    if (this.state.blocked) {
      e.preventDefault()
    }
  }
  
  render() {
    const { t } = this.props;
    return (
      <div id="home-container">
        {!this.state.userLogged && <Redirect to={{ pathname: "/"}} />}
        {this.state.fetching && 
          <Dimmer active>
            <Loader />
          </Dimmer>
        }
        <BrowserView>
          <Container>
            <Header />
            <h1 style={{margin: '0 0 3rem'}}>MEMBER AREA</h1>
            {this.state.user && <div style={{position: 'absolute'}}>
              {this.state.user.picture && <Image src={this.state.user.picture} id="profile-pic" size='small' circular />}
              {!this.state.user.picture && <Icon size='huge' name="user circle outline" id="avatar"/>}
              <h2 style={{margin: '.5rem 0 0'}}>{this.state.user.firstname}</h2>
              <p style={{color: '#6499FF'}}>{this.state.user.email}</p>
            </div>}
            <Tab id="tabs"
              menu={{inverted: true, vertical: true}}
              onTabChange={this.onTabChange.bind(this)}
              panes={[
                { menuItem: { key: 'users', content: t('tabs:profile') }, render: () => <Tab.Pane loading={this.state.fetching}><ProfilePane user={this.state.user} toggleTabs={this.toggleTabs.bind(this)} updateUser={this.updateUser.bind(this)}/></Tab.Pane> },
                { menuItem: { key: 'premium', content: t('tabs:premium') }, render: () => <Tab.Pane><PremiumPane user={this.state.user}/></Tab.Pane> },
                { menuItem: { key: 'gifts', content: t('tabs:gifts') }, render: () => <Tab.Pane><GiftCardsPane user={this.state.user}/></Tab.Pane> },
                { menuItem: { key: 'data', content: t('tabs:pdata') }, render: () => <Tab.Pane><PersonalDataPane user={this.state.user}/></Tab.Pane> },
              ]} />
          </Container>
        </BrowserView>
        <MobileView>
          <Container id="mobile-root">
            <Header />
            <div id="mobile-content">
              <h1>Personal space</h1>
              <ProfileCard loading={this.state.fetching} user={this.state.user} updateUser={this.updateUser.bind(this)}/>
              <PremiumCard user={this.state.user} />
              <GiftCardsCard user={this.state.user}/>
              <PersonalDataCard user={this.state.user} />
            </div>
          </Container>
        </MobileView>
      </div>
    );
  }
}

export default translate('translations')(HomePage);



// WEBPACK FOOTER //
// ./src/pages/HomePage.js